import {CurrentReservationObject, Justification} from "@/views/reservation-detail/ReservationDetail";
import moment from "moment";

export default class FieldVerifications {


  public static isErrorInName(reservation: CurrentReservationObject): boolean {
    if (!FieldVerifications.isDefine(reservation.name)) {
      reservation.errors.name = "Le nom de la réservation n'est pas valide, il ne doit pas être vide.";
      return true;
    }
    return false;
  }

  public static isErrorInDay(reservation: CurrentReservationObject): boolean {
    if (!FieldVerifications.isDayDefine(reservation.day)) {
      reservation.errors.day = "Veuillez choisir une date";
      return true;
    }

    const date = moment(reservation.day, "YYYY-MM-DD");
    if (date.isBefore(moment().startOf('day'))) {
      reservation.errors.day = "La date choisie ne doit pas être antérieure à aujourd'hui";
    }

    return false;
  }

  public static isErrorInHeures(reservation: CurrentReservationObject): boolean {
    if (!FieldVerifications.isHourDefine(reservation.heureDebut)) {
      reservation.errors.heures = "Veuillez choisir une heure de début";
      return true
    }
    if (!FieldVerifications.isHourDefine(reservation.heureFin)) {
      reservation.errors.heures = "Veuillez choisir une heure de fin";
      return true;
    }

    const [startHour, startMinute] = reservation!.heureDebut.split(":");
    const [endHour, endMinute] = reservation!.heureFin.split(":");
    const startTime = moment().hour(parseInt(startHour)).minute(parseInt(startMinute));
    const endTime = startTime.clone().hour(parseInt(endHour)).minute(parseInt(endMinute));

    if (startTime.isAfter(endTime)) {
      reservation.errors.heures = "L'heure de début ne peut pas être postérieur à l'heure de fin";
      return true;
    } else if (startTime.isSame(endTime)) {
      reservation.errors.heures = "L'heure de début ne peut pas être égale à l'heure de fin";
      return true;
    }

    if (FieldVerifications.isDayDefine(reservation.day)) {
      const date = moment(reservation.day, "YYYY-MM-DD");
      if (startTime.isBefore(moment()) && startTime.format('YYYY-MM-DD') === date.format('YYYY-MM-DD')) {
        reservation.errors.heures = "L'heure de début ne peut pas être postérieur à l'heure actuelle";
        return true;
      }
    }

    return false;
  }

  public static isErrorInJustification(justification: Justification): boolean {
    const texte = justification.texte
    justification.error = "";
    if (!FieldVerifications.isDefine(texte) || !FieldVerifications.isLongerThan(texte, 20)) {
      justification.error = "Veuillez entrer un texte d'au moins 20 caractères concernant le changement";
      return true;
    }
    return false;
  }


  //
  // General Checks
  public static isDefine(element: string): boolean {
    return typeof element !== "undefined" && element !== "";
  }

  public static isLongerThan(element: string, length: number): boolean {
    return element.length > length;
  }

  public static isDayDefine(element: string): boolean {
    const regex = /^[0-9]{4}-[0-1][0-9]-[0-3][0-9]$/;
    return (element !== "undefined" && element !== "" && regex.test(element));
  }

  public static isHourDefine(element: string): boolean {
    const regex = /^[0-2][0-9]:[0-5][0-9]$/;
    return (element !== "undefined" && element !== "" && regex.test(element));
  }


}
